export default {
  path: '/plan',
  name: 'Plan',
  redirect: '/plan/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/plan'),
      meta: { requiresAuth: true }
    },
    {
      path: 'adminPlanList',
      component: () => import('@/views/plan/adminPlanList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'yearPlanList',
      component: () => import('@/views/plan/yearPlanList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'yearPlainDetail',
      component: () => import('@/views/plan/yearPlainDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'halfYearPlanList',
      component: () => import('@/views/plan/halfYearPlanList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'halfYearPlainDetail',
      component: () => import('@/views/plan/halfYearPlainDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'monthPlanList',
      component: () => import('@/views/plan/monthPlanList'),
      meta: { requiresAuth: true }
    },
    {
      path: 'monthPlainDetail',
      component: () => import('@/views/plan/monthPlainDetail'),
      meta: { requiresAuth: true }
    },
  ]
}
